import { useContext } from 'react';
import { PedigreeContext } from './PedigreeContext';

// -----------------------------------------------------------------------------
export const usePedigreeContext = () => {
  const context = useContext(PedigreeContext);
  if (context === undefined) {
    throw new Error(
      'usePedigreeContext must be used within a PedigreeProvider'
    );
  }

  // ---------------------------------------------------------------------------
  return context;
};
